import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../mixins';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.core_white};
`;

export const JoinUsWrapper = styled.div`
  ${defaultContainerSize};
  margin-top: 4rem;
  padding-bottom: 4rem;

  ${mq.xLarge(css`
    margin-top: 7.5rem;
    padding-bottom: 8.75rem;
  `)};
`;
